import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function Support() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Support
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    EventFlow support is designed to ensure smooth operations and quick
                    resolution of issues at every stage of usage.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-sm text-slate-600">
                        Our support model focuses on responsiveness, clarity, and practical
                        solutions.
                    </p>
                </section>
            </section>

            {/* SUPPORT CHANNELS */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Support Channels
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>
                        <strong>Email Support:</strong> Detailed technical assistance with 24h turnaround.
                    </li>
                    <li>
                        <strong>Live Chat:</strong> Instant help for quick queries during business hours.
                    </li>
                    <li>
                        <strong>Phone Support:</strong> Direct line to our experts for urgent issues.
                    </li>
                    <li>
                        <strong>Remote Assistance:</strong> Screen sharing sessions for complex troubleshooting.
                    </li>
                </ul>
            </section>

            {/* SUPPORT TIERS */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Support Tiers
                </h2>
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="border border-slate-200 rounded-lg p-6">
                        <h3 className="font-bold text-slate-900 mb-2">Standard Support</h3>
                        <p className="text-sm text-slate-500 mb-4">Included with all plans</p>
                        <ul className="text-sm text-slate-600 space-y-2">
                            <li>Email support (24-48h response)</li>
                            <li>Access to Knowledge Base</li>
                            <li>Community Forum access</li>
                        </ul>
                    </div>
                    <div className="border border-[#C9A24E] rounded-lg p-6 relative overflow-hidden">
                        <div className="absolute top-0 right-0 bg-[#C9A24E] text-white text-xs px-2 py-1 rounded-bl-lg">
                            Recommended
                        </div>
                        <h3 className="font-bold text-slate-900 mb-2">Priority Support</h3>
                        <p className="text-sm text-slate-500 mb-4">For Enterprise plans</p>
                        <ul className="text-sm text-slate-600 space-y-2">
                            <li>24/7 Priority Email & Chat</li>
                            <li>Dedicated Account Manager</li>
                            <li>1-hour response time guarantee</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* WHAT WE HELP WITH */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    What We Help You With
                </h2>

                <div className="grid md:grid-cols-2 gap-4">
                    <ul className="list-disc pl-5 text-slate-600 space-y-2">
                        <li>System configuration and initial setup</li>
                        <li>User role management and permissions</li>
                        <li>Booking calendar conflicts and adjustments</li>
                        <li>Payment gateway integration issues</li>
                    </ul>
                    <ul className="list-disc pl-5 text-slate-600 space-y-2">
                        <li>Report generation and data analysis</li>
                        <li>Data migration from legacy systems</li>
                        <li>Bug reporting and feature requests</li>
                        <li>API integrations and webhooks</li>
                    </ul>
                </div>
            </section>

             {/* SELF-SERVICE RESOURCES */}
             <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Self-Service Resources
                </h2>

                <div className="grid md:grid-cols-3 gap-6">
                    <div className="text-center p-4">
                        <div className="bg-slate-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 text-2xl">
                            📚
                        </div>
                        <h3 className="font-semibold text-slate-800">Knowledge Base</h3>
                        <p className="text-xs text-slate-500 mt-1">
                            Detailed articles and guides.
                        </p>
                    </div>
                    <div className="text-center p-4">
                        <div className="bg-slate-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 text-2xl">
                            🎥
                        </div>
                        <h3 className="font-semibold text-slate-800">Video Tutorials</h3>
                        <p className="text-xs text-slate-500 mt-1">
                            Step-by-step walkthroughs.
                        </p>
                    </div>

                    <Link to="http://forum.eventflow.methologik.com/">
                    <div className="text-center p-4 " >
                        <div className="bg-slate-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 text-2xl">
                            💬
                        </div>
                        <h3 className="font-semibold text-slate-800">Community Forum</h3>
                        <p className="text-xs text-slate-500 mt-1">
                            Connect with other users.
                        </p>
                    </div>
                    </Link>
                </div>
            </section>

            {/* SUPPORT PHILOSOPHY */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Our Support Philosophy
                </h2>

                <p className="text-md text-slate-600 max-w-3xl">
                    We believe support is not just about fixing issues but ensuring
                    long-term system success.
                </p>
            </section>
{/* 
            <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next,{" "}
                    <Link to="/docs/contact" className="font-medium text-[#C9A24E]">
                        Contact Us
                    </Link>.
                </p>
            </section> */}
        <DocNavigation
                    previous={{
                      title: "About Us",
                      link: "/docs/about"
                    }}
                    next={{
                      title: "Contact Us",
                      link: "/docs/contact"
                    }}
                  />
        </section>
    );
}
